export default __webpack_public_path__ + "static/media/history_1970_01.1321ebb7.png";